/**
 * Instagram に出せる画像の設定かを、生成の前に画面で知らせる（docs/instagram/plan.md §7-3・§7-7）。
 * サーバーの生成受付（POST /posts/generate）と同じ条件。押してから 400 で知るのを避けるための案内で、
 * 最終的な判定はサーバーが行う。
 */
import type { AccountSettings } from './postTypes'

export function instagramSettingsProblem(settings: Pick<AccountSettings, 'image'> | undefined): string | null {
  if (!settings) return null
  if (!settings.image.enabled) return 'Instagram に出すには画像が必要です。設定の「画像生成」で「投稿に画像を付ける」をオンにしてください。'
  const koma = settings.image.koma
  if (koma?.format === 'vertical' && (koma.probability ?? 0) > 0) {
    return 'いまの縦のコマ割り（9:16）の画像は、Instagram の縦横比（4:5〜1.91:1）に入りません。設定でコマ割りの確率を 0 にするか、コマ割りの形を「四角（2×2の4コマ）」にしてください。'
  }
  return null
}
